module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "advantage"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ourAdvantage')))]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.advantageList), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": item.imgAlt
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "little-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "describe"
    }, [_vm._v(_vm._s(item.describe))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18f8b5c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliateProgram/advantage/Advantage.vue
// module id = 1270
// module chunks = 1